const longMonthNames: string[] = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const shortMonthNames: string[] = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default function FormatDateFromInt(dateInt?: number) {
  if (dateInt && dateInt > 1990)
    return (dateInt.toString().substring(0, 4) + "-" + dateInt.toString().substring(4, 6) + "-" + dateInt.toString().substring(6, 8))
  else
    return dateInt;
}

export function getCurrentDate() {

  const currentDate = new Date();

  const yyyy = currentDate.getUTCFullYear();
  const mm = currentDate.getUTCMonth() + 1;
  const dd = currentDate.getUTCDate()

  return 10000 * yyyy + 100 * mm + dd;
}

export function FormatDateFromString(dateString?: string) {
  if (dateString) {
    return dateString.split("T")[0];
  }
}

export function FormatDateFromStringWithHours(dateString?: string) {
  if (dateString) {
    return dateString.replace("T", " ").split(".")[0];
  }
}

export function FormatDateFromStringWithHoursFromUTC(dateString?: string) {
  if (!dateString) return "";

  const date = new Date(dateString.endsWith("Z") ? dateString : dateString + "Z");

  if (isNaN(date.getTime())) {
    return dateString;
  }

  return date.toLocaleString("sv-SE").substring(0, 19);
}

export function LongMonthName(monthNumber?: number): string {
  if (monthNumber === undefined) monthNumber = new Date().getMonth() + 1;
  if (monthNumber < 1) monthNumber = 12 + monthNumber;
  return longMonthNames[monthNumber - 1];
}

export function UtcSecondsToLocalDateString(timestamp: number | undefined): string {
  if (!timestamp) return "-";

  const dateTime = new Date(timestamp * 1000);

  // Using 'sv-SE' locale is a common trick to get the YYYY-MM-DD HH:mm format.
  return new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(dateTime);
}
